import React, { useMemo } from 'react';
import { useCallback } from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';
import { getContentCardWidth, renderContentCard } from '@/modules/content/utils/renderContentCard';
import Carousel from '@/modules/corporate/components/Carousel';
import { useAdminRoute } from '@/pages/corporate/routes/hooks/useAdminRoutes';
import { ContentEntity } from '@/types/schema';

import { CARD_TYPE, carouselStyles, CLASSES, headerStyles } from './utils';

export default function ContentRecomendation({
  contents,
  className,
}: {
  contents: ContentEntity[];
  className?: string;
}) {
  const { isMobile, isDesktop } = useScreen();
  const SCREEN_CLASSES = React.useMemo(
    () => ({ ...CLASSES, header: headerStyles(isMobile) }),
    [isMobile],
  );

  const processedContents = useMemo(() => {
    if (isMobile) {
      return contents.slice(0, 2);
    }
    return contents.slice(0, 4);
  }, [contents, isMobile]);

  const itemWidth = isMobile ? 150 : getContentCardWidth(CARD_TYPE, isMobile);

  const isAdminRoute = useAdminRoute();
  const renderCard = useCallback(
    (index: number) => {
      const content = processedContents[index] as ContentEntity;
      return renderContentCard({
        content,
        cardType: CARD_TYPE,
        isAdminRoute,
        isMobile,
      });
    },
    [isAdminRoute, isMobile, processedContents],
  );

  return (
    <Stack className={cn('carousel', className)} direction="col" gapY={24}>
      <Stack>
        <Typography className={cn({ 'pl-8': !isMobile })} variant="heading-s">
          Suggested Learnings
        </Typography>
      </Stack>
      <Carousel
        key={'recommendation'}
        className={cn(carouselStyles(isMobile), SCREEN_CLASSES?.carousel)}
        navigation={!isMobile}
        renderSlide={renderCard}
        showShadows={true}
        slidesPerView="auto"
        spaceBetween={isMobile ? 14 : 24}
        speed={isDesktop ? 900 : 300}
        totalCount={processedContents.length}
        classes={SCREEN_CLASSES}
        // itemHeight={276}
        itemWidth={itemWidth}
      />
    </Stack>
  );
}
